import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamFlowsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamFlowsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
